import { setGlobalLoading } from '@/index';

export function ErrorBoundary() {
  useLayoutEffect(() => {
    setGlobalLoading(false);
  });
  return (
    <Result
      style={{ padding: '200px 0' }}
      status="error"
      title="OH NO! PAGE ERROR!"
      subTitle="Please click the button below to refresh the page."
      extra={[
        <Button
          key="refresh"
          onClick={() => {
            location.reload();
          }}
        >
          Refresh
        </Button>,
      ]}
    ></Result>
  );
}
